import { DeleteOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import LinkButton from 'components/LinkButton';
import { Modal } from 'components/ui';

const EditActions = ({
  isInputValid = true,
  onEdit,
  onCancel,
  onSave,
  onRemove,
  removeText,
  onRemoveMessaging,
  record,
  editing,
  canEdit = () => false,
  canRemove = () => false,
}) => {
  const { t } = useTranslation();
  const resolvedRemoveText = removeText ?? t('common.remove', 'Remove');
  const resolvedRemoveMessaging =
    onRemoveMessaging ??
    t(
      'common.deleteConfirmPermanent',
      'This action is permanent. Are you sure you want to delete?'
    );
  const buttonProps = {
    value: record.id,
    type: 'button',
  };
  if (!canEdit() && !canRemove()) {
    return null;
  }

  if (editing) {
    return (
      <Fragment>
        <LinkButton data-testid="cancelEditBtn" {...buttonProps} onClick={onCancel}>
          {t('common.cancel', 'Cancel')}
        </LinkButton>
        <Divider type="vertical" />
        {isInputValid ? (
          <LinkButton
            id="edit-save-link-button"
            data-testid="saveEditBtn"
            {...buttonProps}
            onClick={onSave}
          >
            {t('common.save', 'Save')}
          </LinkButton>
        ) : null}
      </Fragment>
    );
  }
  return (
    <Fragment>
      {canEdit() && (
        <LinkButton data-testid="edit-button" {...buttonProps} onClick={onEdit}>
          {t('common.edit', 'Edit')}
        </LinkButton>
      )}
      {canRemove() && onRemove && (
        <Fragment>
          <Divider type="vertical" />
          <LinkButton
            {...buttonProps}
            onClick={() => {
              Modal.confirm({
                title: t('common.confirmTitle', 'Are you sure?'),
                icon: <DeleteOutlined />,
                content: resolvedRemoveMessaging,
                onOk: () => {
                  onRemove(record.id);
                },
                okText: resolvedRemoveText,
              });
            }}
          >
            {resolvedRemoveText}
          </LinkButton>
        </Fragment>
      )}
    </Fragment>
  );
};

export default EditActions;
